export const OPEN_STATUS_MODAL = "statusModal/OPEN_STATUS_MODAL";
export const CLOSE_STATUS_MODAL = "statusModal/CLOSE_STATUS_MODAL";